<script setup lang="ts">
import { assetCDN } from '~/helper'

defineProps({
  destination: { type: String, default: '' },
})
const text = [
  'Standard of accommodation and proximity to the city centre.',
  'The number of activities, experiences and meals included.',
  'The number of travellers and the final dates that chosen.',
]
const emits = defineEmits(['close'])
const ASSETS_CDN = assetCDN()
</script>

<template>
  <div class="hp-100">
    <div class="sticky top-0 bg-white z-999" id="header-form" :style="`height:54px`">
      <div class="flex pt-8 pb-4 justify-end items-center px-16">
        <div class="flex items-center px-8 py-8">
          <button @click.prevent="emits('close')">
            <img :src="`${ASSETS_CDN}/images/enquiryB2C/icon-close.png`" alt="Close" />
          </button>
        </div>
      </div>
    </div>
    <div class="px-16 overflow-auto" style="height: 500px">
      <p class="fs-18 fw-700 lh-24 mb-16">Why is this a price range?</p>
      <p class="mb-4">
        The estimated price range is based on our experience in designing trips to {{ destination }} and the time of year you are travelling and the standard of
        accomodation.
      </p>
      <p class="mb-8">
        The final price will vary depending on a number of factors, but should fall within this estimate. Factors that can affect the final price are:
      </p>
      <ul>
        <li v-for="(t, i) in text" :key="i" class="mb-8 flex">
          <img :src="`${ASSETS_CDN}/images/enquiryB2C/icon-check-circle.png`" alt="Icon" class="h-16 w-16 mt-2" />
          <span class="ml-4">{{ t }}</span>
        </li>
      </ul>
      <p>
        With fully customisable itineraries we can work with you to achieve the very best value. We can amend the variables such as accommodation and inclusions
        to the best of our ability to ensure the final price sits within your desired budget.
      </p>
    </div>
    <div class="sticky bottom-0 left-0 z-999 wp-100 footer-form px-16 pt-10 pb-7 bg-white">
      <button id="enquiry-form-price-range-button-got-it" class="button button-primary wp-100" type="button" @click.prevent="emits('close')">Got it</button>
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
